import React, { useState } from "react"
import FarmsMap from "./FarmsMap"
import { useSubscription } from "@apollo/client"
import { GET_FARMS_SUBSCRIPTION } from "../../gql/all_farms_sub"
import { allFarmsToGeoJson } from "../../utils/geoJson"
import { CircularProgress, Grid } from "@mui/material"
import FarmSummary from "./FarmSummary"

export default function Farms() {
  const { data, loading, error } = useSubscription(GET_FARMS_SUBSCRIPTION)
  const [activeFarm, setActiveFarm] = useState(null)

  if (loading) return <CircularProgress />
  if (error) {
    console.log(error)
    return <div>There was an error connecting to the server</div>
  }
  console.log(data)
  const farms = data?.farm || []
  const farmsGeoJson = allFarmsToGeoJson(farms)

  const activeFarmDetails = activeFarm
    ? farms.find((farm) => farm.id === activeFarm)
    : null
  return (
    <Grid container spacing={3}>
      {activeFarm && (
        <Grid item xs={3}>
          <FarmSummary activeFarmDetails={activeFarmDetails} />
        </Grid>
      )}
      <Grid item xs={activeFarm ? 9 : 13}>
        <FarmsMap
          farmsGeoJson={farmsGeoJson}
          activeFarm={activeFarm}
          setActiveFarm={setActiveFarm}
        />
      </Grid>
    </Grid>
  )
}
